export const svSE = {
  app: {
    categories: {
      convectors: 'Konvektorer',
      decorative: 'Dekorativ',
      electric: 'Elektrisk',
      panels: 'Paneler',
      towel: 'Handdukstork',
    },
    categoryLabel: 'Kategori',
    categoryPlaceholder: 'Välj en kategori',
    errorCategories: 'Kunde inte hämta kategorier.',
    errorPanels: 'Kunde inte hämta radiatorer.',
    loadingCategories: 'Laddar kategorier...',
    loadingPanels: 'Laddar radiatorer...',
    panelLabel: 'Radiatorer',
    panelPlaceholder: 'Välj en radiator',
    titles: {
      convectors: 'Kalkylator för konvektorer',
      decorative: 'Kalkylator för designradiatorer',
      electric: 'Kalkylator för elektriska radiatorer',
      panels: 'Kalkylator för panelradiatorer',
      towel: 'Kalkylator för handdukstorkar',
    },
  },
  calc: {
    actionButton: 'Visa beräknade artiklar',
    boost: 'Boostläge',
    calculateRequiredButton: 'Beräkna värmebehov',
    calculating: 'Beräknar...',
    comfort: 'Komfortläge',
    downloadLabel: 'Ladda ner data ({count})',
    emptyResults: 'Inga resultat än.',
    errorMatch: 'Kunde inte beräkna resultat.',
    errorTypes: 'Kunde inte hämta paneltyper.',
    flowTemp: 'Tillopp C°',
    height: 'Höjd',
    length: 'Längd',
    loadingTypes: 'Laddar typer...',
    modeLabel: 'Läge',
    modes: {
      cooling: 'Kyla',
      heating: 'Värme',
    },
    radiatorType: 'Radiatortyp',
    requiredWatts: 'Värmebehov (watt)',
    resultsMessage: '{count} artiklar tillgängliga för valda inställningar.',
    returnTemp: 'Retur C°',
    roomTemp: 'Rumstemperatur C°',
    selectAllLabel: 'Välj alla artiklar',
    selectItemLabel: 'Välj artikel för nedladdning',
    selectPanel: 'Välj en radiator för att beräkna.',
    standby: 'Standbyläge',
    tableHeaders: {
      calculatedWattage: 'Effekt',
      co2Equivalent: 'CO2-ekvivalent per kg material',
      depth: 'Djup [mm]',
      description: 'Artikel- beskrivning',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Höjd [mm]',
      itemId: 'Artikelkod',
      length: 'Längd [mm]',
      waterContent: 'Vattenvolym',
      weight: 'Vikt',
    },
    title: 'Beräkningar',
    tolerance: 'Tolerans',
    typeCooling: 'Kylning',
    typeGroupLabel: 'Typ',
    typeHeating: 'Uppvärmning',
  },
  existingRadiator: {
    description:
      'Denna kalkylator är endast avsedd för information. Rådfråga alltid en professionell installatör för att få den exakta beräkningen innan du köper radiatorn.',
    height: 'Radiatorhöjd',
    length: 'Radiatorlängd',
    resultLabelTemplate: 'Värmeeffektbehov, beräknat med {temp} i systemtemperatur',
    select: 'Välj',
    temperature: 'Systemtemperatur',
    type: 'Radiatortyp',
  },
  matrixCalc: {
    axisHeight: 'Höjd (mm)',
    axisLength: 'Längd (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Visning',
    exportExcel: 'Exportera till Excel',
    exportPdf: 'Exportera till PDF',
    print: 'Skriv ut',
    hideOutOfRange: 'Dölj artiklar utanför intervallet',
    showAll: 'Visa alla',
    loading: 'Loading...',
    lockHeight: 'Höjd',
    lockLabel: 'Lås dimension',
    lockLength: 'Längd',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Beräkna',
    clearButton: 'Rensa',
    fields: {
      ceilingHeight: 'Takhöjd',
      doorInsulation: 'Dörrisolering',
      floorInsulation: 'Golvisolering',
      glazingArea: 'Glasyta',
      glazingMode: 'Glasyta',
      glazingQuality: 'Glaskvalitet',
      length: 'Längd',
      outerWalls: 'Ytterväggar',
      projectedDesignTemp: 'Dimensionerande utetemp',
      roofInsulation: 'Takisolering',
      roomArea: 'Rumsarea',
      roomFloor: 'Våningsplan',
      roomInsulation: 'Rumsisolering',
      roomPreset: 'Rumstyp',
      roomTemperature: 'Rumstemperatur',
      roomType: 'Rumstyp',
      uncertaintyFactor: 'Osäkerhetsfaktor',
      ventilation: 'Ventilationsnivå',
      wallInsulation: 'Väggisolering',
      width: 'Bredd',
      windConditions: 'Vindförhållanden',
      windowInsulation: 'Fönsterisolering',
    },
    intro:
      'Beräkna värmeförlusten i rummet för att kunna välja rätt produkt från vårat sortiment av värmeavgivare.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mer än 20%',
        low: 'Mindre än 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Över 20%',
        below_10: 'Under 10%',
        from_10_to_20: 'Mellan 10% till 20%',
        no_windows: 'Inga fönster',
      },
      insulationValue: {
        good: 'Bra',
        medium: 'Genomsnittlig',
        poor: 'Svag',
        very_good: 'Mycket bra',
      },
      qualityValue: {
        modern_excellent: 'Energisnåla, 3-glasfönster',
        modern_good: 'Moderna, täta, med isolerglas',
        old_poor: 'Gamla, slitna, otäta',
        traditional_medium: 'Traditionella i gott skick, extra tätade',
      },
      roomValue: {
        bathroom_24: 'Badrum (24 C°)',
        bedroom_20: 'Sovrum (20 C°)',
        garage_12: 'Garage (12 C°)',
        livingroom_22: 'Vardagsrum (22 C°)',
        storage_16: 'Förråd (16 C°)',
      },
      select: 'Välj',
      storeyValue: {
        ground_multi: 'Bottenvåning (flervåningshus)',
        ground_single: 'Bottenvåning (enplanshus)',
        interim: 'Mellanvåning',
        top_multi: 'Översta våningen (flervåningshus)',
      },
      temp: {
        climate_zone_1: 'DUT -12 C°',
        climate_zone_2: 'DUT -14 C°',
        climate_zone_3: 'DUT -16 C°',
        climate_zone_4: 'DUT -18 C°',
        climate_zone_5: 'DUT -20 C°',
        climate_zone_6: 'DUT -22 C°',
        climate_zone_7: 'DUT -24 C°',
        climate_zone_8: 'DUT -26 C°',
      },
      windInfluence: {
        normal: 'Normala',
        strong: 'Ogynnsamma',
        weak: 'Gynnsamma',
      },
    },
    roomPresets: {
      bathroom: 'Badrum',
      bedroom: 'Sovrum',
      garage: 'Garage',
      kitchen: 'Kök',
      living: 'Vardagsrum',
      storage: 'Förråd',
    },
    sections: {
      dimensions: 'Rumsdimensioner',
      insulation: 'Isolering',
      placement: 'Placering',
      result: 'Resultat',
      temps: 'Temperaturer',
      ventilation: 'Ventilation',
    },
    title: 'Kalkylator för värmebehov',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Använd',
  },
  slider: {
    from: 'Från',
    to: 'Till',
    value: 'Värde',
  },
}
